// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"lba-z","subtitle":"mba-z","wrapper":"nba-z","leftArrow":"oba-z","rightArrow":"pba-z"};